import { render, staticRenderFns } from "./BusinessRegistrationLogs.vue?vue&type=template&id=5a1ff9fd&"
import script from "./BusinessRegistrationLogs.vue?vue&type=script&lang=js&"
export * from "./BusinessRegistrationLogs.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRegistrationLogs.vue?vue&type=style&index=0&id=5a1ff9fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports